import React from "react";
import { useTranslation } from "react-i18next";
import SingleSolution from "./SingleSolution";

const ServiceAreaFive = () => {
  const { t } = useTranslation();
  const maxSuite = t("max-suite", { returnObjects: true });
  return (
    <>
      {/*=================== service area five start ===================*/}
      <div
        id="solutions"
        className="service-area scroll bg-gray bg-relative pd-top-120 pd-bottom-120"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center">
                <h3 className="sub-title-sky-blue">{t("max-solution")}</h3>
                <h4 className="title">{t("max-solution-slogan")}</h4>
              </div>
            </div>
          </div>
          <div className="row custom-no-gutter">
            <div className="col-lg-4 col-md-6">
              {maxSuite.slice(0, 3).map((solution) => (
                <SingleSolution
                  key={solution.id}
                  id={solution.id}
                  title={solution.title}
                  icon={solution.icon}
                  subtitle={solution.subtitle}
                  slogan={solution.slogan}
                />
              ))}
            </div>
            <div className="col-lg-4 col-md-6 bg-blue-right d-lg-inline-block d-none">
              <div className="service-thumb service-middle-section align-self-end">
                <img src="/assets/images/MAX.png" alt="img" />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              {maxSuite.slice(3, 6).map((solution) => (
                <SingleSolution
                  key={solution.id}
                  id={solution.id}
                  title={solution.title}
                  icon={solution.icon}
                  subtitle={solution.subtitle}
                  slogan={solution.slogan}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* =================== service area end ===================*/}
    </>
  );
};

export default ServiceAreaFive;
